import { useEffect, useState } from "react";
import { getUserToken } from "../../../helper/commonFunction";
import { ApiCall } from "../../../helper/axios";
import { getActiveCode, getActiveRate } from "../../../helper/currencyState";
import moment from "moment";

export const useDoConfirm = (time, endTime, variationId, eventId) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  let userToken = getUserToken();

  const save = async ({
    time,
    endTime,
    variationId,
    eventId,
    variationTitle,
    date,
    paymentMethod,
    transfer,
    eId,
    price,
    persons,
    isEmaar,
    tickets,
    isHelidubai,
    isDubaiPark,
    isDubaiProductId,
    TourProductId,
    TourScheduleId,
    TourId,
    duration,
    bookingReference,
    jwt,
    IsEventBased,
    transactionId='',
    onlinePayment={},
    openDay,
    vendorBased,
    emaarV1Tickets,
    IsEticketRequired,
    isEmaarV1,
    slotData,
    taxData,
    raynaData,
    parmarData,
    commonId
  }) => {
    try {
      setLoading(true);
      setError(null);
      let IsEvent = IsEventBased === 'false' ? false : true
      const adults = persons?.filter((d) => d?.type === "adult") ?? [];
      const childSeats = persons?.filter((d) => d?.type === "child");
      const infantSeats = persons?.filter((d) => d?.type === "infant");

      let slots = {
        ProductId: variationId,
        EventID: eventId,
        StartDateTime: (IsEvent && isEmaar) ? moment(time).format("YYYY-MM-DD HH:mm:ss") : moment(time).format("YYYY-MM-DD"),
        EndDateTime: (IsEvent && isEmaar) ? moment(endTime).format("YYYY-MM-DD HH:mm:ss") : moment(time).format("YYYY-MM-DD"),
      }
      let payload = {
        bookingReference,
        transactionId,
        paymentMethod,
        onlinePayment,
        display_currency: getActiveCode(),
        conversion_rate: getActiveRate(),
        NoramlData: {
          excursion_id: eId,
          variation_id: variationId,
          variation_title: variationTitle,
          TourDate: moment(date).format("YYYY-MM-DD"),
          price: price,
          transferType: transfer,
          paymentMethod: paymentMethod,
          startTime: IsEvent ?  moment(time).format("YYYY-MM-DD HH:mm:ss") :  moment(time).format("YYYY-MM-DD"),
          endTime: IsEvent ? moment(endTime).format("YYYY-MM-DD HH:mm:ss"): moment(time).format("YYYY-MM-DD"),
          eventId: eventId,
          PaxInformation: persons,
          isOpenday: openDay === 'true' ? true : false,
          productVendorConfirmationBase: vendorBased === 'true' ? true : false,
          IsEticketRequired,
          vatRateType : taxData?.vatRateType,
          exclusiveOrInclusive : taxData?.exclusiveOrInclusive
        },
        isEmaar,
        EmaarData: isHelidubai || isDubaiPark
          ? {}
          : {
              GuestName: `${adults?.[0]?.firstName} ${adults?.[0]?.lastName}`,
              GuestEmail: adults?.[0]?.email ?? "",
              GuestMobile: adults?.[0]?.phoneNumber ?? "",
              Tickets: tickets,
              TimeSlot: slots,
            },
        isHeliDubaiTour: isHelidubai,
        heliDubaiTourData : {
          jwt : jwt,
          LeadPassengerName : `${adults?.[0]?.firstName} ${adults?.[0]?.lastName}`,
          phoneNumber : adults?.[0]?.phoneNumber,
          email : "",
          flightNumber : TourScheduleId,
          tourId : TourId,
          NumberOfPassengers : persons?.length,
          BookingReference : "",
          remarks: "Test remarks",
          Weights1: "",
          Weights2: "",
          Weights3: "",
          Weights4: "",
          Weights5: "",
          termsAndConditions: "1",
          extras: [
            // {
            //   eid: "E1",
            //   einfo: "E1"
            // },
          ],
        },
        isDubaiPark,
        DubaiParkData : isDubaiPark ? {
          ProductList: [
            {
              ProductId: isDubaiProductId,
              Quantity: persons?.length
            }
          ],
          ResellerBookingId: generateAlphanumericString(20),
          CustomerInfo: {
            Title: "",
            FirstName: adults?.[0]?.firstName || childSeats?.[0]?.firstName,
            LastName: adults?.[0]?.lastName || childSeats?.[0]?.lastName,
            EmailAddress: "",
            MobilePhoneNumber: "",
            ResidenceCountry: adults?.[0]?.nationality?.toUpperCase() || childSeats?.[0]?.nationality?.toUpperCase(),
            Nationality: adults?.[0]?.nationality?.toUpperCase() || childSeats?.[0]?.nationality?.toUpperCase()
          },
          PaymentMethod: {
            PaymentMethodId: 12,
            PaymentDate: dubaiParkformatDate(new Date()),
            TransactionCode: generateAlphanumericString(8)
          }
        } : {},
      };
      if (isEmaarV1) {
        payload = {
          ...payload,
          isEmaarV1: true,
          EmaarDataV1: {
            Tickets: emaarV1Tickets,
            TimeSlot: {
              "EventID": slotData?.EventID,
              "EventName": slotData?.EventName,
              "StartDateTime":slotData?.StartDateTime,
              "EndDateTime": slotData?.EndDateTime,
              "EventTypeId": slotData?.EventTypeId,
              "ResourceID": slotData?.ResourceID,
              "Available": slotData?.Available,
              "Status": slotData?.Status
            }
          }
        }
      }
      if (commonId) {
        payload.commonId = commonId;
      }

      if (raynaData?.vendor === "rayna") {
        payload = {
          vendor: "rayna",
          commonId: raynaData?.commonId ?? commonId ?? "",
          bookingReference,
          transactionId,
          paymentMethod,
          onlinePayment,
          display_currency: getActiveCode(),
          conversion_rate: getActiveRate(),
          NoramlData: {
            excursion_id: String(raynaData?.excursionId ?? eId ?? ""),
            variation_id: String(raynaData?.tourOptionId ?? variationId ?? ""),
            variation_title: String(raynaData?.variationTitle ?? variationTitle ?? ""),
            contractId: String(raynaData?.contractId ?? ""),
            transferId: String(raynaData?.transferId ?? ""),
            timeSlotId: String(raynaData?.timeSlotId ?? ""),
            TourDate: moment(date).format("YYYY-MM-DD"),
            startTime: raynaData?.startTime ?? "",
            adultRate: raynaData?.adultRate ?? 0,
            childRate: raynaData?.childRate ?? 0,
            serviceTotal: raynaData?.serviceTotal ?? price,
            pickup: raynaData?.pickup ?? "",
            originalPrices: raynaData?.originalPrices,
            ...(raynaData?.googleNavigation
              ? { googleNavigation: raynaData.googleNavigation }
              : {}),
            address: raynaData?.address ?? "",
            importantInformation: raynaData?.importantInformation ?? "",
            PaxInformation: persons,
          },
        };
      }

      if (parmarData?.vendor === "parmar") {
        payload = {
          vendor: "parmar",
          commonId: parmarData?.commonId ?? commonId ?? "",
          bookingReference,
          transactionId,
          paymentMethod,
          onlinePayment,
          display_currency: getActiveCode(),
          conversion_rate: getActiveRate(),
          NoramlData: {
            excursion_id: String(parmarData?.excursionId ?? eId ?? ""),
            variation_id: String(parmarData?.variationId ?? variationId ?? ""),
            variation_title: String(parmarData?.variationTitle ?? variationTitle ?? ""),
            parmarKind: String(parmarData?.parmarKind ?? "single"),
            TourDate: moment(date).format("YYYY-MM-DD"),
            entry_time: parmarData?.entry_time ?? "",
            exit_time: parmarData?.exit_time ?? "",
            startTime: parmarData?.entry_time
              ? `${moment(date).format("YYYY-MM-DD")} ${parmarData.entry_time}`
              : moment(date).format("YYYY-MM-DD"),
            adultTicketId: parmarData?.adultTicketId ?? null,
            childTicketId: parmarData?.childTicketId ?? null,
            infantTicketId: parmarData?.infantTicketId ?? null,
            noOfAdult: adults?.length ?? 0,
            noOfChild: childSeats?.length ?? 0,
            noOfInfant: infantSeats?.length ?? 0,
            adultRate: parmarData?.adultRate ?? 0,
            childRate: parmarData?.childRate ?? 0,
            serviceTotal: parmarData?.serviceTotal ?? price,
            address: parmarData?.address ?? "",
            importantInformation: parmarData?.importantInformation ?? "",
            PaxInformation: persons,
          },
        };
      }

      const details = await ApiCall(
        "POST",
        `/excursions/book`,
        payload,
        {}
      );

      const body = details?.data;
      const unwrapped = body?.statusCode && body?.data ? body.data : body;

      return { ...details, data: unwrapped };
    } catch (error) {
      setError(error?.message);
    } finally {
      setLoading(false);
    }
  };

  const dubaiParkformatDate = (date) => {
    const pad = (n) => (n < 10 ? '0' + n : n);

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const year = date.getFullYear();

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  const generateAlphanumericString = (length = 20) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      result += chars[randomIndex];
    }

    return result;
  }




  return {
    save,
    data,
    loading,
    error,
  };
};
